import { toast } from "sonner";
import customFetch from "../util/config/axiosConfig";
import { Ptm } from "../types/SchedulePtm";
import { getErrorMessage } from "../util/functions/UniversalFunctions";

const schedulePtmApis = {
  // post
  schedulePtm: async (payload: Ptm) => {
    try {
      const response = await customFetch.post("/api/v1/ptm", payload);

      if (response.data.status === 1) {
        toast.success("PTM scheduled successfully!");
      } else {
        toast.error(response.data.error || "Failed to schedule PTM");
      }

      return response.data;
    } catch (error: any) {
      toast.error(getErrorMessage(error) || "Error scheduling PTM");
      throw error;
    }
  },

  //get
  getPtmsByBranch: async (branchCode: string) => {
    const res = await customFetch.get(`/api/v1/ptm/${branchCode}`);
    return res.data.data;
  },

  // update
  updatePtm: async (payload: Ptm & { ptmId: number }) => {
    try {
      const response = await customFetch.put("/api/v1/ptm", payload);

      if (response.data.status === 1) {
        toast.success("PTM updated successfully!");
      } else {
        toast.error(response.data.error || "Failed to update PTM");
      }

      return response.data;
    } catch (error: any) {
      toast.error(getErrorMessage(error) || "Error updating PTM");
      throw error;
    }
  },

  canclePtm: async (ptmId: number) => {
    try {
      const response = await customFetch.delete(
        `/api/v1/ptm/${ptmId}`
      );
      toast.success("PTM has been cancelled successfully");
      return response.data;
    } catch (err: any) {
      toast.error(getErrorMessage(err) || "Failed to cancle Ptm");
    }
  },
};

export default schedulePtmApis;
